import {
  addDoc,
  collection,
  getDocs,
  query,
  serverTimestamp,
  where,
  setDoc,
  doc,
  increment,
  writeBatch,
} from "firebase/firestore";
import { db, dbRealtime } from "../firebaseConfig";
import { sendMail } from "./functions";
import {
  push,
  ref as realtimeRef,
  set,
  serverTimestamp as realtimeTimestamp,
  update,
} from "firebase/database";
import { create } from "@mui/material/styles/createTransitions";
import { getFunctions, httpsCallable } from "firebase/functions";

export const addCampaignPromoCode = async (payload) => {
  console.log(payload, "payload1111");
  // Use promoCode as the document key
  const docRef = doc(collection(db, "campaigns"), payload.promoCode);
  await setDoc(docRef, { ...payload, createdAt: new Date() });
  console.log("Campaign added with promoCode as key:", payload.promoCode);
  return docRef;
};

export const addCampaignReferral = async (payload) => {
  console.log(payload, "payload1111");
  // Use promoCode as the document key
  const docRef = doc(collection(db, "campaigns"));
  await setDoc(docRef, { ...payload, createdAt: new Date() });
  return docRef;
};

export const addCampaignFundWallet = async (payload) => {
  const docRef = doc(collection(db, "campaigns"));
  await setDoc(docRef, { ...payload, createdAt: serverTimestamp() });
  return docRef;
};

export const getCampaigns = async () => {
  const q = query(collection(db, "campaigns"));
  const querySnapshot = await getDocs(q);
  const arr = [];
  querySnapshot.forEach((doc) => {
    arr.push({ ...doc.data(), id: doc.id });
  });
  return arr;
};

export const checkPromoCodeAvailability = async (promoCode) => {
  const campaignDetailsQuery = query(
    collection(db, "campaigns"),
    where("campaignType", "==", "promo_code"),
    where("promoCode", "==", promoCode),
  );
  const campaignDetails = await getDocs(campaignDetailsQuery);
  return campaignDetails.empty ? true : false;
};

export const notifyCustomersOffer = async (
  isAll,
  customers,
  selectedCustomers,
  campaignDetails,
  loginUser,
) => {
  console.log(isAll, customers, selectedCustomers, "notifyCustomersOffer");
  const finalCustomers = isAll
    ? customers
    : customers?.filter((customer) =>
        selectedCustomers?.includes(customer?.email),
      );
  console.log(finalCustomers, "finalCustomersdssdf");
  await Promise.all(
    finalCustomers?.map(async (customer) => {
      await sendMail({
        email: customer?.email,
        subject: `🎉 Enjoy ${campaignDetails?.totalDiscount}% Off on Your Next ${campaignDetails?.usedFor} with POSTPAL!`,
        content: generatePromoCodeEmailTemplate({
          discount: campaignDetails?.totalDiscount,
          usedFor: campaignDetails?.usedFor,
          maxDisAmount: campaignDetails?.maxDisAmount,
          isNoMaxAmount: campaignDetails?.isNoMaxAmount,
          promoCode: campaignDetails?.promoCode,
          expiryDate: campaignDetails?.expiryDate,
          isNeverExpire: campaignDetails?.isNeverExpire,
          publicNote: campaignDetails?.publicNote,
          isAppliedToAllCouriers: campaignDetails?.isAppliedToAllCouriers,
          isAppliedToAllBrands: campaignDetails?.isAppliedToAllBrands,
          appliedCouriers: campaignDetails?.appliedCouriers,
          appliedBrands: campaignDetails?.appliedBrands,
          name: customer?.name,
          adminName: loginUser?.name,
        }),
      });
    }),
  );

  // await sendMail({
  //     email: userDetails?.emailId,
  //     // email: "prayank@postpal.com",
  //     subject: "Package Received at POSTPAL Warehouse!",
  //     content: ""
  // })
};
export const notifyCustomersMessage = async (
  isAll,
  customers,
  selectedCustomers,
  messageDetails,
  loginUser,
) => {
  console.log(isAll, customers, selectedCustomers, "notifyCustomersOffer");
  const finalCustomers = isAll
    ? customers
    : customers?.filter((customer) =>
        selectedCustomers?.includes(customer?.email),
      );
  console.log(finalCustomers, "finalCustomersdssdf");
  await Promise.all(
    finalCustomers?.map(async (customer) => {
      await sendMail({
        email: customer?.email,
        subject: messageDetails?.header,
        content: generatePostpalMessage(messageDetails, customer?.email),
      });
    }),
  );

  // await sendMail({
  //     email: userDetails?.emailId,
  //     // email: "prayank@postpal.com",
  //     subject: "Package Received at POSTPAL Warehouse!",
  //     content: ""
  // })
};

export const notifyCustomersForReferralOffer = async (
  isAll,
  customers,
  selectedCustomers,
  referralDetails,
  loginUser,
) => {
  const finalCustomers = isAll
    ? customers
    : customers?.filter((customer) =>
        selectedCustomers?.includes(customer?.email),
      );
  console.log(finalCustomers, "finalCustomersdssdf");
  await Promise.all(
    finalCustomers?.map(async (customer) => {
      await sendMail({
        email: customer?.email,
        subject: "💼 You've Been Enrolled in the POSTPAL Referral Program!",
        content: generateReferralOfferMail(
          { ...customer, ...referralDetails },
          loginUser,
        ),
      });
    }),
  );
};

export const sendInAppMessage = async (
  isAll,
  customers,
  selectedCustomers,
  messageDetails,
  loginUser,
) => {
  const finalCustomers = isAll
    ? customers
    : customers?.filter((customer) =>
        selectedCustomers?.includes(customer?.id),
      );
  console.log(finalCustomers, "finalCustomersdssdf");
  const chatRef = realtimeRef(
    dbRealtime,
    "orderChats/POSTPAL_ANOUNCEMENT/chats",
  );
  const newChatEntryRef = push(chatRef); // Create a new unique key for the message

  const messageId = newChatEntryRef.key; // Get the generated messageId

  await set(newChatEntryRef, {
    message: messageDetails?.appMessage,
    date: realtimeTimestamp(),
    sentBy: loginUser?.id,
    users: finalCustomers,
    messageId: messageId,
    messageType: "text",
  }).then(async (res) => {
    const chatRefOrder = realtimeRef(
      dbRealtime,
      `orderChats/POSTPAL_ANOUNCEMENT`,
    );

    update(chatRefOrder, {
      adminId: loginUser.id,
      lastMessageDate: realtimeTimestamp(),
    })
      .then(() => {
        // toast.success("OrderChatActive updated successfully.");
      })
      .catch((error) => {
        console.error("Error updating data:", error);
      });
  });
};

export const sendReceiveMessageNotification = async (
  title,
  isAll,
  customers,
  selectedCustomers,
  messageDetails,
  loginUser,
) => {
  const finalCustomers = isAll
    ? customers
    : customers?.filter((customer) =>
        selectedCustomers?.includes(customer?.email),
      );
  console.log(messageDetails, "messageDetailsasddf");
  const functions = getFunctions();
  const sendPushNotification = httpsCallable(functions, "sendPushNotification");
  await Promise.all(
    finalCustomers.map(async (user) => {
      const notificationPayload = {
        body: messageDetails?.mobileMessage,
        desc: "",
        identifier: user?.phoneNumber,
        isRead: false,
        sentOn: serverTimestamp(),
        title: title,
        type: "MESSAGE",
        userId: user?.id,
        actionText: "",
      };
      console.log(notificationPayload, "notificationPayloadbvnh");

      const notification = await addDoc(
        collection(db, "notifications"),
        notificationPayload,
      );
      if (user?.fcmToken) {
        const payload = {
          token: user?.fcmToken,
          title: title,
          body: messageDetails?.mobileMessage,
          data: {
            identifier: user?.phoneNumber,
            type: "MESSAGE",
          },
        };
        try {
          const result = await sendPushNotification(payload);
          console.log("sendPushNotification result:", result.data);
        } catch (error) {
          console.error("sendPushNotification error:", error);
        }
      }
    }),
  );
  return {
    success: true,
    message: "Receive Message Notification sent successfully",
  };
};

export const generatePromoCodeEmailTemplate = (data) => {
  const returnAppliedForCouriers = (
    appliedCouriers,
    isAppliedToAllCouriers,
  ) => {
    if (data?.usedFor === "shipping" || data?.usedFor === "global") {
      return isAppliedToAllCouriers
        ? "All Couriers"
        : appliedCouriers?.map((courier) => courier?.display).join(", ");
    }
    return null;
  };
  const returnAppliedForBrands = (appliedBrands, isAppliedToAllBrands) => {
    if (data?.usedFor === "shopping" || data?.usedFor === "global") {
      return isAppliedToAllBrands
        ? "All Brands"
        : appliedBrands?.map((brand) => brand?.name).join(", ");
    }
    return null;
  };
  const returnFundUsage = (usedFor) => {
    switch (usedFor) {
      case "shopping":
        return "Shopping";
      case "shipping":
        return "Shipping";
      case "global":
        return "Shopping & Shipping";
      default:
        return "";
    }
  };
  const returnFundUsageAction = (usedFor) => {
    switch (usedFor) {
      case "shopping":
        return "shopping request";
      case "shipping":
        return "shipment";
      case "global":
        return "shipment or shopping request";
      default:
        return "";
    }
  };
  const returnFundUsageInstruction = (usedFor) => {
    switch (usedFor) {
      case "shopping":
        return "Create a shopping request";
      case "shipping":
        return "Create a shipment request";
      case "global":
        return "Create a shipment or shopping request";
      default:
        return "";
    }
  };

  const returnTagline = (usedFor) => {
    switch (usedFor) {
      case "shipping":
        return "Use this when you ship with POSTPAL.";
      case "shopping":
        return "Use this when submitting a POSTPAL Purchase Assistance request for your international shopping needs.";
      case "global":
        return "Whether you're planning to ship a package, shop from international stores, or both — this is for you.";
      default:
        return "";
    }
  };
  return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>POSTPAL Promotional Offer</title>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, Helvetica, sans-serif; background-color: #f4f4f4;">
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background-color: #f4f4f4;">
        <tr>
            <td align="center" style="padding: 20px 0;">
                <table role="presentation" width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                    <!-- Header -->
                    <tr>
                        <td style="padding: 20px; background-color: #5e17eb; color: #ffffff; text-align: center; border-top-left-radius: 8px; border-top-right-radius: 8px;">
                            <h1 style="margin: 0; font-size: 24px; color: #ffffff;">🎉 Save ${data?.discount || ""}% on Your Next ${returnFundUsage(data?.usedFor) || ""}!</h1>
                            <p style="margin: 10px 0 0; font-size: 16px;">${returnTagline(data?.usedFor)}</p>
                        </td>
                    </tr>
                    <!-- Body -->
                    <tr>
                        <td style="padding: 30px;">
                            <p style="font-size: 16px; color: #333333;">Hi ${data?.name},</p>
                            <p style="font-size: 16px; color: #333333; line-height: 1.5;">
                                You're receiving this special <strong>POSTPAL promo code</strong>, available exclusively for use during checkout in the POSTPAL mobile app. Save instantly on your next ${returnFundUsageAction(data?.usedFor) || ""}.
                            </p>
                            <table role="presentation" width="100%" cellpadding="10" style="background-color: #f8f9fa; border-radius: 8px; margin: 20px 0;">
                                <tr>
                                    <td style="font-size: 16px; color: #333333;">
                                        <h2 style="margin: 0; font-size: 18px; color: #5e17eb;">✨ Promo Details:</h2>
                                        <p><strong>Discount:</strong> ${data?.discount || ""}%</p>
                                        <p><strong>Maximum Discount:</strong> ${data?.isNoMaxAmount ? "No Maximum" : "$" + data?.maxDisAmount || ""}</p>
                                        <p><strong>Promo Code:</strong> <span>${data?.promoCode || ""}</span></p>
                                        <p><strong>Valid For:</strong> ${returnFundUsage(data?.usedFor) || ""}</p>
                                        <p><strong>Expires:</strong> ${data?.isNeverExpire ? "Never" : data?.expiryDate || ""}</p>
                                        <p><strong>Note:</strong> ${data?.publicNote || ""}</p>
                                        ${returnAppliedForCouriers(data?.appliedCouriers, data?.isAppliedToAllCouriers) ? `<p><strong>Applied For Couriers:</strong> ${returnAppliedForCouriers(data?.appliedCouriers, data?.isAppliedToAllCouriers) || ""}</p>` : ""}
                                        ${returnAppliedForBrands(data?.appliedBrands, data?.isAppliedToAllBrands) ? `<p><strong>Applied For Brands:</strong> ${returnAppliedForBrands(data?.appliedBrands, data?.isAppliedToAllBrands) || ""}</p>` : ""}
                                    </td>
                                </tr>
                            </table>
                            <h2 style="font-size: 18px; color: #333333;">📲 How to Use It:</h2>
                            <ol style="font-size: 16px; color: #333333; line-height: 1.5;">
                                <li>Open or install the POSTPAL Mobile App</li>
                                <li>${returnFundUsageInstruction(data?.usedFor) || ""}</li>
                                <li>Proceed to checkout</li>
                                <li>Enter your promo code <strong>${data?.promoCode || ""}</strong></li>
                                <li>Enjoy your discount instantly!</li>
                            </ol>
                            <p style="font-size: 16px; color: #333333; line-height: 1.5;">
                                This offer was created just for you by <strong>${data?.adminName || ""}</strong> — don't miss out!
                            </p>
                        </td>
                    </tr>
                    <!-- Footer -->
                    <tr>
                        <td style="padding: 20px; background-color: #f8f9fa; text-align: center; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
                            <p style="font-size: 14px; color: #333333; margin: 0;">
                                <strong>Need Help?</strong> Contact us anytime at <a href="mailto:team@postpal.me" style="color: #5e17eb; text-decoration: none;">support@postpal.com</a>
                            </p>
                            <p style="font-size: 14px; color: #333333; margin: 10px 0 0;">
                                Thank you for using POSTPAL,<br>Team POSTPAL
                            </p>
                            <br /><br />
                            <span>If you want to unsubscribe promotional email please <a href="#">click here</a>.</span>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;
};

export const generatePostpalMessage = (data, email) => {
  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${data?.header}</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      background-color: #f4f4f4;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 600px;
      margin: 30px auto;
      background-color: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    }
    .header {
      background-color: #007bff;
      color: #ffffff;
      padding: 20px;
      text-align: center;
      font-size: 22px;
    }
    .sub-header {
      background-color: #eaf1ff;
      color: #333;
      padding: 10px 20px;
      font-size: 14px;
      text-align: center;
    }
    .body {
      padding: 20px;
      color: #333;
      line-height: 1.6;
    }
    .footer {
      background-color: #f8f9fa;
      padding: 15px 20px;
      font-size: 14px;
      color: #666;
      text-align: center;
    }
    a {
      color: #007bff;
      text-decoration: none;
    }
    a:hover {
      text-decoration: underline;
    }
  </style>
</head>
<body>
  <div class="email-container">
    <div class="header">
      ${data?.header}
    </div>
    <div class="sub-header">
      This message was sent to you by the POSTPAL Team.
    </div>
    <div class="body">
      ${data?.message}
    </div>
    <div class="footer">
      If you have any questions, feel free to contact our support team at
      <a href="mailto:support@postpal.com">support@postpal.com</a>.<br />
      Thanks for being with POSTPAL,<br />
      Team POSTPAL
      <br /><br />
      <span>If you want to unsubscribe promotional email please <a href="http://localhost:3000/unsubscribe?email=${encodeURIComponent(email || "")}">click here</a>.</span>
    </div>
  </div>
</body>
</html>
`;
};

export const generateReferralOfferMail = (data, loginUser) => {
  return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>POSTPAL Referral Program</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f4f4f4;
        }
        .container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #ffffff;
            padding: 20px;
        }
        .header {
            text-align: center;
            padding: 20px 0;
            background-color: #5e17eb;
            color: #ffffff;
        }
        .header h1 {
            margin: 0;
            font-size: 24px;
        }
        .content {
            padding: 20px;
        }
        .content h2 {
            color: #333333;
            font-size: 20px;
        }
        .content p {
            color: #555555;
            line-height: 1.6;
        }
        .details {
            background-color: #f9f9f9;
            padding: 15px;
            border-radius: 5px;
            margin: 20px 0;
        }
        .details p {
            margin: 5px 0;
        }
        .cta {
            text-align: center;
            margin: 20px 0;
        }
        .cta a {
            display: inline-block;
            padding: 10px 20px;
            background-color: #007bff;
            color: #ffffff;
            text-decoration: none;
            border-radius: 5px;
        }
        .footer {
            text-align: center;
            padding: 20px;
            color: #777777;
            font-size: 14px;
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <h1>Earn Revenue When Your Referrals Ship with POSTPAL</h1>
        </div>
        <div class="content">
            <h2>Hi ${data?.name || ""},</h2>
            <p>We're excited to welcome you into the <strong>POSTPAL Referral Program</strong> — designed to help creators, influencers, and affiliates like you earn money every time someone you refer ships with us.</p>
            
            <div class="details">
                <h3>💰 Your Earning Details:</h3>
                <p><strong>Commission Rate:</strong> ${data?.referralBonus || ""}% of each qualifying shipment</p>
                <p><strong>Eligible Activity:</strong> ${data?.referralType || ""}</p>
                <p><strong>Payout Cap per Shipment:</strong> ${data?.maxReferralAmount || ""}</p>
                <p><strong>Valid Until:</strong> ${data?.isNeverExpire ? "Never Expire" : data?.expiryDate || ""}</p>
                <p><strong>Note:</strong> ${data?.publicNote || ""}</p>
            </div>

            <h3>📈 How It Works:</h3>
            <ul>
                <li>Share your POSTPAL referral link with your audience</li>
                <li>When a referred user completes a ${data?.referralType || ""}, you'll earn ${data?.referralBonus || ""}%</li>
                <li>Your earnings will be added to your POSTPAL wallet automatically</li>
                <li>Track your earnings and referrals directly from your dashboard</li>
            </ul>

            <p>This campaign was created for you by ${loginUser?.name || ""}. Be sure to activate your network and make the most of it!</p>
            <p>If you have any questions or want to learn how top referrers earn more, we're here for you at <a href="mailto:support@postpal.com">support@postpal.com</a>.</p>


            <p>Happy earning,<br>Team POSTPAL</p>
        </div>
        <div class="footer">
            <p>&copy; 2025 POSTPAL. All rights reserved.</p>
        </div>
    </div>
</body>
</html>`;
};

const generateUniqueCode = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const generatePromoCode = async (codeLength) => {
  const code = generateUniqueCode(codeLength);
  const result = await checkPromoCodeAvailability(code);
  if (result) {
    return code;
  } else {
    return generatePromoCode(codeLength);
  }
};

// ─── Fund Wallet Helpers ────────────────────────────────────────────────────

/**
 * Add a single wallet transaction record to the `walletTransactions` collection.
 */
export const addWalletTransaction = async (
  userId,
  walletId,
  amount,
  note = "",
  routePartnerId = ["ALL"],
  applicableToAllRoutePartners = true,
) => {
  try {
    const payload = {
      applicableToAllRoutePartners,
      paymentTransactionId: "",
      paymentType: "FUND_WALLET_CAMPAIGN",
      routePartnerId, // New key added
      transactAt: serverTimestamp(),
      transactVia: "ADMIN",
      transactionAmount: amount,
      transactionNote: note,
      transactionType: "CREDIT",
      updatedAt: serverTimestamp(),
      userId,
      walletId,
    };
    return await addDoc(collection(db, "walletTransactions"), payload);
  } catch (err) {
    throw new Error(
      `Failed to log wallet transaction for user "${userId}": ${err.message}`,
    );
  }
};

/**
 * Fetch the wallet document for a specific user from the `wallets` collection
 * using the userId field stored on each wallet doc.
 * @param {string} userId
 * @returns {Promise<{id: string, userId: string, walletBalance: number, ...}>}
 */
const getWalletByUserId = async (userId) => {
  try {
    const snapshot = await getDocs(
      query(collection(db, "wallets"), where("userId", "==", userId)),
    );
    if (snapshot.empty)
      throw new Error(
        `No wallet found for user "${userId}". The user may not have a wallet yet.`,
      );
    return { id: snapshot.docs[0].id, ...snapshot.docs[0].data() };
  } catch (err) {
    throw new Error(
      err.message.startsWith("No wallet")
        ? err.message
        : `Failed to fetch wallet for user "${userId}": ${err.message}`,
    );
  }
};

/**
 * Increment walletBalance on a specific wallet doc by walletId, then log a transaction.
 * @param {string} userId
 * @param {string} walletId
 * @param {number} amount
 * @param {string} note
 */
const creditUserWallet = async (userId, walletId, amount, note) => {
  try {
    const walletRef = doc(db, "wallets", walletId);
    const batch = writeBatch(db);
    batch.update(walletRef, {
      allRoutePartnerBalance: increment(amount),
      routePartnersWalletBalance: increment(amount),
    });
    await batch.commit();
    await addWalletTransaction(userId, walletId, amount, note, ["ALL"], true);
  } catch (err) {
    throw new Error(
      err.message.startsWith("Failed")
        ? err.message
        : `Failed to credit wallet "${walletId}" for user "${userId}": ${err.message}`,
    );
  }
};

/**
 * Fetch mapUserRoutePartners entries for a specific user and a list of route partner IDs.
 */
const getMapEntriesForUser = async (userId, routePartnerIds) => {
  if (!routePartnerIds.length) return [];
  try {
    const snapshot = await getDocs(
      query(
        collection(db, "mapUserRoutePartners"),
        where("userId", "==", userId),
        where("routePartnerId", "in", routePartnerIds),
      ),
    );
    return snapshot.docs.map((d) => ({ docId: d.id, ...d.data() }));
  } catch (err) {
    throw new Error(
      `Failed to fetch mappings for user "${userId}": ${err.message}`,
    );
  }
};

/**
 * Increment routePartnerWalletBalance on matching mapUserRoutePartners docs,
 * increment the user's main walletBalance, and log a walletTransaction.
 */
const creditRoutePartnerWallet = async (
  userId,
  routePartnerIds,
  amount,
  note,
) => {
  try {
    const entries = await getMapEntriesForUser(userId, routePartnerIds);

    if (!entries.length) return;
    const wallet = await getWalletByUserId(userId);

    const batch = writeBatch(db);

    // 1. Update map references
    for (const entry of entries) {
      const mapRef = doc(db, "mapUserRoutePartners", entry.docId);
      batch.update(mapRef, { routePartnerWalletBalance: increment(amount) });
    }

    // 2. Update main wallet
    const walletRef = doc(db, "wallets", wallet.id);
    batch.update(walletRef, { routePartnersWalletBalance: increment(amount) });

    await batch.commit();
    const routePartnerIdVal =
      routePartnerIds.length > 0 ? routePartnerIds : ["ALL"];
    await addWalletTransaction(
      userId,
      wallet.id,
      amount,
      note,
      routePartnerIdVal,
      false,
    );
  } catch (err) {
    // Re-throw with context if not already descriptive
    throw new Error(
      err.message.startsWith("Failed") ||
        err.message.startsWith("No route") ||
        err.message.startsWith("No wallet")
        ? err.message
        : `Failed to credit route partner wallet for user "${userId}": ${err.message}`,
    );
  }
};

/**
 * Main function to add funds to wallets based on the form submission.
 * userIds and routePartnerIds are always fully resolved before this is called.
 *
 * Case A — isAllRoutePartners: credit `walletBalance` on each user's wallet doc.
 * Case B — specific RPs:       credit `routePartnerWalletBalance` on mapUserRoutePartners.
 *
 * All errors are thrown with human-readable messages so the UI can display them directly.
 */
export const addFundWallet = async ({
  isAllRoutePartners,
  userIds,
  routePartnerIds,
  amount,
  note = "",
  campaignData,
}) => {
  // ── Case A: All route partners → credit walletBalance ────────────────────
  // userIds is always a fully-populated list (resolved in the component).
  // For each userId, look up their wallet and credit it directly.
  if (isAllRoutePartners) {
    const results = await Promise.allSettled(
      userIds.map(async (userId) => {
        const wallet = await getWalletByUserId(userId);
        await creditUserWallet(userId, wallet.id, amount, note);
      }),
    );
    const failures = results.filter((r) => r.status === "rejected");
    if (failures.length) {
      const messages = failures.map((f) => f.reason?.message).join(" | ");
      throw new Error(
        failures.length === userIds.length
          ? `All operations failed: ${messages}`
          : `Partial failure — ${failures.length} of ${userIds.length} user(s) failed: ${messages}`,
      );
    }
  } else {
    // ── Case B: Specific route partners → credit routePartnerWalletBalance ───
    // userIds and routePartnerIds are both fully resolved by the caller.
    const results = await Promise.allSettled(
      userIds.map((userId) =>
        creditRoutePartnerWallet(userId, routePartnerIds, amount, note),
      ),
    );
    const failures = results.filter((r) => r.status === "rejected");
    if (failures.length) {
      const messages = failures.map((f) => f.reason?.message).join(" | ");
      throw new Error(
        failures.length === userIds.length
          ? `All operations failed: ${messages}`
          : `Partial failure — ${failures.length} of ${userIds.length} user(s) failed: ${messages}`,
      );
    }
  }

  // ── Log global campaign entry if provided ──
  if (campaignData) {
    await addCampaignFundWallet(campaignData);
  }
};
